package org.example.zone360.pages.coachDetails.coachAssistAi

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.icons.fa.FaXmark
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.createCheckoutSession
import kotlinx.coroutines.launch
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomDivider
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.players_Details.assistAI.SuperscriptDollarText
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Res
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun CoachAnnualSubscriptions(
    onDialogDismiss: () -> Unit,
    sitePalette: SitePalette,
    toastMessage: (String) -> Unit,
    breakpoint: Breakpoint,
    getCoachInfo : GetSingleCoachData){
    val scope = rememberCoroutineScope()
    var isLoading by remember { mutableStateOf(false) }

    Box(modifier = Modifier.fillMaxSize().position(Position.Fixed).zIndex(999)
        .backgroundColor(Palette.Grey.rgbLight.copyf(alpha = 0.7f)),
        contentAlignment = Alignment.Center) {
        Box(
            modifier = Modifier
                .width(if (breakpoint < Breakpoint.MD) 400.px else 460.px),
            contentAlignment = Alignment.Center){
            Box(
                modifier = Modifier
                    .width(90.percent)
                    .height(100.percent)
                    .onClick { }
            )
            Box(
                modifier = Modifier
                    .width(90.percent)
                    .margin(top = 10.px)
                    .height(100.percent)
                    .backgroundColor(sitePalette.modalBackgroundColor.rgb)
                    .border(
                        width = 1.px,
                        color = sitePalette.textFieldBorderColor.rgb,
                        style = LineStyle.Solid
                    )
                    .borderRadius(4.px)
                ,
                contentAlignment = Alignment.Center,
            ) {
                Column(modifier = Modifier.fillMaxSize()) {
                    Row(
                        horizontalArrangement = Arrangement.SpaceBetween,
                        modifier = Modifier
                            .fillMaxWidth()
                            .padding(15.px)
                            .margin(bottom = 20.px),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        FieldTitleTextNormalSimple(
                            "Coach Annual Subscription",
                            fontSize = 20.px,
                            fontWeight = 600,
                            onClick = {}
                        )

                        FaXmark(
                            modifier = Modifier
                                .color(sitePalette.commonButtonSupportiveTextColor.rgb)
                                .cursor(Cursor.Pointer)
                                .onClick { onDialogDismiss() },
                            size = IconSize.LG
                        )

                    }
                    SuperscriptDollarText(amount = "199", fontSize = 50.px)
                    FieldTitleTextNormalSimple(
                        "+$6 Processing fee",
                        width = 100.percent,
                        marginBottom = 40.px,
                        marginTop = 8.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Unlimited recording",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Valid for 12 months",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )

                    Row(Modifier.fillMaxWidth().padding(leftRight = 15.px),
                        horizontalArrangement = Arrangement.Center) {
                        CommonButton(
                            text = "Select",
                            onCLick = {
                                scope.launch {
                                    isLoading = true
                                    try {
                                        val response = createCheckoutSession(
                                            priceID = Res.Price.coachPriceId,
                                            organization =getCoachInfo.organization,
                                            userID = getCoachInfo.uid,
                                            email = getCoachInfo.email,
                                            stripCustomerID = if (AppGlobal.userData.stripCustomerID == null) "" else  AppGlobal.userData.stripCustomerID!!,
                                        )
                                        if (response.checkout_url != null) {
                                            isLoading = false
                                            val url = response.checkout_url
                                            if (url!!.isNotBlank()) {
                                                kotlinx.browser.window.open(url, "_self")
                                            }

                                        } else {
                                            toastMessage(response.error!!)
                                            showToast("toastError")
                                        }
                                    }catch (e: Throwable){
                                        isLoading = false
                                        toastMessage(e.message.toString())
                                        showToast("toastError")
                                    }
                                }
                            },
                            width = 100.percent,
                            isLoading = isLoading
                        )
                    }
                    CustomDivider(modifier = Modifier.margin(topBottom = 30.px))
                    FieldTitleTextNormalSimple(
                        "Unlimited Training analysis",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Unlimited Match analysis",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Unlimited Player Assessment",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Hands-free lock-screen recording",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                    FieldTitleTextNormalSimple(
                        "Shareable PDF",
                        width = 100.percent,
                        marginBottom = 20.px,
                        textAlign = TextAlign.Center
                    )
                }
            }
        }

        }
    }
